import { Grid, makeStyles, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
// I18n
import { useTranslation } from "react-i18next";
import { classes as workerStyles } from "./AddWorkerStyles";
import UserIds from "./UserIds";

const useStyles = makeStyles((theme) => workerStyles(theme));

export const UserAccess = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { workerRoles, setWorkerRoles, selectedRegion, setSelectedRegion } =
    props;
  const { regions, validateWorkerRoles } = props;
  const { systems } = props.regions;

  const container = {
    marginTop: 10,
    marginBottom: 30,
  };
  const theme = useTheme();

  return (
    <>
      {/* <Seperator color={theme.lightGrey} /> */}
      <Typography
        variant="h6"
        gutterBottom
        className={`${classes.employeeId} ${classes.title}`}
      >
        {t("pgAddWorker.lblIMWarehouseUserAccess")}
      </Typography>
      <Grid container direction="row" justify="space-around" style={container}>
        {systems &&
          regions &&
          systems.map((sys) => (
            <Grid item xs={4} key={sys}>
              <UserIds
                system={sys}
                regions={regions[sys]}
                selectedRegion={selectedRegion}
                setSelectedRegion={setSelectedRegion}
                workerRoles={workerRoles}
                setWorkerRoles={setWorkerRoles}
                validateWorkerRoles={validateWorkerRoles}
              />
            </Grid>
          ))}
      </Grid>
    </>
  );
};

UserAccess.propTypes = {
  regions: PropTypes.object.isRequired,
  workerRoles: PropTypes.object,
  setWorkerRoles: PropTypes.func.isRequired,
  selectedRegion: PropTypes.object.isRequired,
  setSelectedRegion: PropTypes.func.isRequired,
  validateWorkerRoles: PropTypes.func.isRequired,
};
export default UserAccess;
